import Drawer from "../common/Drawer";
import { ajax, dateToString, smoothScrollTo } from "../utils";
import DateVisitor from "./DateVisitor";
import { computeReduction } from "./Experience/ComputeReduction";

class SessionFilters{
  constructor(){
    this.wrapper = document.querySelector('.session-filters-wrapper');
    if(this.wrapper){
      this.drawerOpenerButtonText = this.wrapper.querySelector('.session-filters-drawer-opener-button-text');

      this.adultsPicker = this.wrapper.querySelector('input[name=adults]');
      this.childrenPicker = this.wrapper.querySelector('input[name=children]');
      this.langs = [];
      this.langSvgUrl = '';
      this.langsCheckboxes = this.wrapper.querySelectorAll('.session-lang');
      this.from = null;
      // this.to = null;

      //loading state/div when the flatpickr is initializing
      this.initializingCalendarDiv = this.wrapper.querySelector('.initializing-calendar');

      //init the date/visitor component
      new DateVisitor(this.wrapper);

      //init the flatpickr
      this.humanDate = this.wrapper.querySelector('.human-date');
      this.initFlatpickr();

      this.initLangs();

      this.applyFiltersButton = this.wrapper.querySelector('#update-session-filters');

      this.filtersRecap = this.wrapper.querySelector('.filters-recap');
      this.nbExperiencesBlock = this.wrapper.querySelector('.nb-experiences');
      if(this.filtersRecap && this.nbExperiencesBlock){
        this.filtersRecapDate = this.filtersRecap.querySelector('.filters-recap__date');
        this.filtersRecapPersons = this.filtersRecap.querySelector('.filters-recap__persons');
        this.filtersRecapLangFlagContainer = this.filtersRecap.querySelector('.filters-recap__lang_flag_container');
        this.filtersRecapLangFlag = this.filtersRecap.querySelector('.filters-recap__lang_flag');
      }

      //we need this to scroll to this section once the filters are applied
      this.experiencesSection = document.getElementById('experiences');

      //by default, scroll to experiences section when filters are applied
      this.scrollToExperiences = true;

      //bind the reset filters button
      this.initResetFilters();

      //bind the apply filters button
      this.filtersErrorMessage = this.wrapper.querySelector('#session-filters-error-message');
      this.initApplyFilters();

      if(this.wrapper.hasAttribute('trigger-check-on-page-load')){
        this.triggerCheckOnPageLoad();
      }
    }
  }

  /**
   * Initializes the flatpickr date picker.
   *
   * @param {}
   * @return {}
   */
  initFlatpickr(){
    const _this = this;
    const datepickr = this.wrapper.querySelector('.flatpickr');
    if(datepickr){
      this.flatpickr = DateVisitor.initDatePicker(datepickr, {
        inline: true,
        altInput: true,
        altFormat: "l, M J, Y",
        dateFormat: "Y-m-d",
        defaultDate: datepickr.dataset.defaultDate ?? null,
        minDate: new Date(),
        onChange: function(selectedDates, dateStr) {
          _this.setHumanDate(selectedDates);

          if(selectedDates.length > 0) {
            _this.from = selectedDates[0];

            DateVisitor.switchToVisitorsOnDateClick();
          }
        },
        onReady: function(selectedDates, dateStr, instance) {
          if(_this.initializingCalendarDiv) _this.initializingCalendarDiv.remove();

          if(selectedDates.length > 0) {
            _this.from = selectedDates[0];
          }

          _this.rContainer = instance.calendarContainer.querySelector('.flatpickr-rContainer');

          _this.setHumanDate(selectedDates);
        }
      });

      // bind the clear date button
      // clears the calendar container.
      this.bindClearDate();
    }
  }

  setHumanDate(selectedDates){
    if(selectedDates.length === 1 && this.humanDate) {
      this.humanDate.innerHTML = selectedDates[0].toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      this.humanDate.classList.add("font-semibold");
      this.humanDate.parentElement.classList.add('value-set');
    }
  }

  /**
   * Initializes the filtered languages.
   *
   * This function adds event listeners to each language checkbox. When a checkbox is checked,
   * the corresponding language ID is added to the `langs` array. When a checkbox is unchecked,
   * the corresponding language ID is removed from the `langs` array.
   *
   * @return {void}
   */
  initLangs(){
    this.langsCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if(checkbox.checked){
          this.langs = [checkbox.value];
          this.langSvgUrl = checkbox.dataset.svgUrl;
        }
      });
    });

    //at page load, init the langs already checked
    this.langsCheckboxes.forEach(checkbox => {
      if(checkbox.checked){
        this.langs.push(checkbox.value);
        this.langSvgUrl = checkbox.dataset.svgUrl;
      }
    });
  }


  /**
   * Updates the session with the current values.
   *
   */
  updateSession() {
    const data = new FormData();

    data.append('adults', this.adultsPicker.value);
    data.append('children', this.childrenPicker.value);
    data.append('from', this.from ? dateToString(this.from) : false);
    // data.append('to', dateToString(this.to));
    data.append('langs', JSON.stringify(this.langs));

    // ajax call with current values to update session on server side
    ajax(this.wrapper.dataset.updateSessionUrl, (data) => {
      this.checkExperiencesAvailability();
    },
    'POST', data);
  }

  /**
   * Checks the availability of experiences based on the selected date, number of people, and languages.
   *
   * @return {void}
   */
  checkExperiencesAvailability() {
    const _this = this;
    const cards = document.querySelectorAll('[data-experience-check-availability]');

    // check timeslots only if datepicker has a value
    if(this.from) {
      this.ajaxRequestsRunning = 0;

      cards.forEach(function (card) {
        card.classList.add('loading');
        // card.classList.add('slots-displayed');

        _this.ajaxRequestsRunning++;
        ajax(`/api/experience/${card.dataset.experienceId}/timeslots?date=${dateToString(_this.from)}&languages=any&adults=${_this.adultsPicker.value}&children=${_this.childrenPicker.value}`, function (data) {
          const timeslotsContainer = card.querySelector('.card-experience-host-page__timeslots-available');
          card.classList.add('filters-applied');

          if (data.timeslots.length === 0) {
            card.classList.add('not-available');
            timeslotsContainer?.classList.add('hidden');

            _this.toggleOfferExperienceButtonHidden(card, false);

            //change the text content of the book CTA
            const bookCTA = card.querySelector('.card-experience-host-page__check_other_availabilities span');
            if(bookCTA){
              bookCTA.textContent = bookCTA.dataset.otherDatesText;
            }

            // Clear the filtered price
            _this.clearFilteredPrice(card);
          }
          else {
            _this.toggleOfferExperienceButtonHidden(card, true);

            //in this case, we want to show the timeslots on the experience card itself, so users can book quickly by clicking on a timeslot
            timeslotsContainer?.classList.remove('hidden');

            if(timeslotsContainer){
              //first, build the timeslots elements
              timeslotsContainer.innerHTML = _this.buildTimeslotsContainer(data.timeslots);

              //then bind them
              _this.bindTimeslotsButtons(timeslotsContainer);
            }

            card.classList.remove('not-available');

            // Update the price display to show the total for the filtered visitors
            _this.updateFilteredPrice(card, data.timeslots[0]);
          }

          card.classList.remove('loading');

          _this.ajaxRequestsRunning--;
          _this.checkIfAllRequestsDone();
        });
      });
    }
    else {
      cards.forEach(function (card) {
        card.classList.remove('not-available', 'filters-applied');

        const timeslotsContainer = card.querySelector('.card-experience-host-page__timeslots-available');
        timeslotsContainer?.classList.add('hidden');
        _this.toggleOfferExperienceButtonHidden(card, false);

        //change the text content of the book CTA back to initial
        const bookCTA = card.querySelector('.card-experience-host-page__check_other_availabilities span');
        if(bookCTA){
          bookCTA.textContent = bookCTA.dataset.initialText;
        }

        // Clear the filtered price
        _this.clearFilteredPrice(card);
      });

      this.filteringDone();
    }
  }

  //Build the HTML element for timeslots, so users can click on them to quickly book
  buildTimeslotsContainer(timeslots){
    let timeslotsElements = '';
    let maxDatesShown = 4; //max dates shown
    let datesShown = 0;
    let countTotalDates = 0;

    //first, check if there are timeslots available in the lang that the user chose
    //if there are, build the timeslots elements
    timeslots.forEach(timeslot => {
      timeslot.slot_languages.forEach(lang => {
        if(lang.id == this.langs[0]){
          if(datesShown < maxDatesShown){
            timeslotsElements += this.getTimeslotDivHtml(timeslot, lang.id, true, lang.svg_url);
            datesShown++;
          }

          countTotalDates++;
        }
      });
    });

    //at this point, if there are no timeslots in the user language chose
    //show all timeslots (even in languages that the user did NOT chose)
    if(datesShown === 0){
      countTotalDates = 0;

      timeslots.forEach(timeslot => {
        timeslot.slot_languages.forEach(lang => {
          if(datesShown < maxDatesShown){
            timeslotsElements += this.getTimeslotDivHtml(timeslot, lang.id, true, lang.svg_url);
            datesShown++;
          }

          countTotalDates++;
        });
      });
    }

    //at this point, we show max dates, so check if there is another timeslot after that
    //if so, show the "see more" button
    // if(datesShown === maxDatesShown && countTotalDates > datesShown){
    //   seeMoreDatesButton?.classList.remove('hidden');
    // }

    return timeslotsElements;
  }

  getTimeslotDivHtml(timeslot, langId, showFlag = true, langSvgUrl = null){
    let flag = showFlag ? `<span class="flex-shrink-0 ml-2 hide-when-loading"><img src="${langSvgUrl}" width="19" class="rounded-sm quick-checkout-flag" /></span>` : '';
    // let btnClass = window.matchMedia('(max-width: 639px)').matches ? 'btn-me-red' : 'btn-outline-me-red btn-sm';

    let html = `
    <div class="z-20 px-1 mt-2">
      <button type="button" class="w-full btn btn-outline-deep-green tiny-loading timeslot-quick-checkout flex items-center justify-center"
        data-slot-id="${timeslot.id}"
        data-slot="${timeslot.start}"
        data-lang-id="${langId}"
        data-seats-adults="${this.adultsPicker.value}"
        data-seats-children="${this.childrenPicker.value}"
        data-date="${timeslot.date}"
      >
        <span class="hide-when-loading">${timeslot.start}</span>
        ${flag}
      </button>
    </div>
    `;

    return html;
  }

  bindTimeslotsButtons(timeslotsContainer){
    const buttons = timeslotsContainer.querySelectorAll('.timeslot-quick-checkout');
    if(buttons){
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          //get the form & fill the fields with the buttons/timeslot data
          const form = button.closest('form');

          const slotId = form.querySelector("[name='slot_id']");
          if(slotId) slotId.value = button.dataset.slotId;

          const slot = form.querySelector("[name='slot']");
          if(slot) slot.value = button.dataset.slot;

          const langId = form.querySelector("[name='lang_id']");
          if(langId) langId.value = button.dataset.langId;

          const seatsAdults = form.querySelector("[name='seats_adult']");
          if(seatsAdults) seatsAdults.value = button.dataset.seatsAdults;

          const seatsChildren = form.querySelector("[name='seats_child']");
          if(seatsChildren) seatsChildren.value = button.dataset.seatsChildren;

          const date = form.querySelector("[name='date']");
          if(date) date.value = button.dataset.date;

          //disable all buttons
          buttons.forEach(innerButton => {
            innerButton.disabled = true;
          });

          //also disable the book button
          const bookButtonsWrapper = form.closest('.book-buttons-wrapper');
          if(bookButtonsWrapper){
            const bookButtons = bookButtonsWrapper.querySelectorAll('.drawer-book-button');
            bookButtons.forEach(bookButton => {
              bookButton.disabled = true;
            });
          }

          button.classList.add('loading');
          form.submit();
        });
      });
    }
  }

  //hide the offer experience button
  toggleOfferExperienceButtonHidden(wrapper, hide){
    const button = wrapper.querySelector('.btn-offer-experience');
    if(button){
      button.classList.toggle('lg:hidden', hide);
      button.classList.toggle('lg:block', !hide);
    }
  }

  /**
   * Binds a click event to the clear date button and resets the calendar date.
   *
   */
  bindClearDate(){
    const clearDateButton = this.wrapper.querySelector('.container-calendar-visitor__clear_date');
    if(clearDateButton){
      clearDateButton.addEventListener('click', () => {
        this.clearFlatpickr();
      });
    }
  }

  /**
   * Clears the flatpickr calendar date and sets the 'from' variable to null.
   *
   * @param {}
   * @return {}
   */
  clearFlatpickr(){
    //reset the calendar date
    this.flatpickr.clear();
    this.from = null;

    //also clear the human date below the date picker
    this.humanDate.textContent = this.humanDate.dataset.initialText;
    this.humanDate.parentElement.classList.remove('value-set');
  }

  /**
   * Clears the values of the adultsPicker and childrenPicker.
   *
   * @param {}
   * @return {}
   */
  clearVisitors(){
    this.adultsPicker.value = 0;
    this.childrenPicker.value = 0;

    //to update the value on the UI
    [this.adultsPicker, this.childrenPicker].forEach(input => {
      input.dispatchEvent(new Event('change'));
    });
  }

  /**
   * Clears the language checkboxes by setting their checked property to false.
   *
   * @param {}
   * @return {}
   */
  clearLangs(){
    this.langsCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    this.langs = [];
    this.langSvgUrl = '';
  }

  /**
   * Resets the filters in session.
   *
   */
  initResetFilters(){
    const resetFiltersButton = this.wrapper.querySelector('#reset-session-filters');
    if(resetFiltersButton){
      resetFiltersButton.addEventListener('click', () => {
        //clear all filters first
        this.clearFlatpickr();
        this.clearVisitors();
        this.clearLangs();

        //hide the filters recap & show the nb of experiences block
        this.filtersRecap.classList.add('hidden');
        this.nbExperiencesBlock.classList.remove('hidden');

        //set back the initial text for the button
        if(this.drawerOpenerButtonText)
          this.drawerOpenerButtonText.textContent = this.drawerOpenerButtonText.dataset.initialText;

        //then update session
        this.updateSession();
      });
    }

  }

  /**
   * Applies the filters and updates the session.
   *
   * @param {}
   * @return {}
   */
  initApplyFilters(){
    this.applyFiltersButton.addEventListener('click', () => {
      //if all filters are not filled, show error message
      if(!((this.adultsPicker.value > 0 || this.childrenPicker.value > 0) /*&& this.langs.length > 0*/ && this.from !== null)){
        this.filtersErrorMessage.classList.remove('hidden');
        this.applyFiltersButton.classList.add('hidden');

        window.setTimeout(() => {
          this.filtersErrorMessage.classList.add('hidden');
          this.applyFiltersButton.classList.remove('hidden');
        }, 3000);

        return;
      }

      //otherwise, proceed to filtering
      this.startFiltering();
      this.updateSession();

      //update infos (date - visitors - lang) on the filters recap in the navbar
      const date = this.from.toLocaleDateString(document.body.dataset.lang.replace("_", "-"), { year: 'numeric', month: 'numeric', day: 'numeric' });
      this.filtersRecapDate.textContent = date;

      this.filtersRecapPersons.textContent = this.filtersRecap.dataset.persText.replace('{0}', Number(this.adultsPicker.value) + Number(this.childrenPicker.value));

      if(this.filtersRecapLangFlagContainer && this.filtersRecapLangFlag){
        if(this.langSvgUrl){
          this.filtersRecapLangFlagContainer.classList.remove('hidden');
          this.filtersRecapLangFlag.src = this.langSvgUrl;
        }
        else{
          this.filtersRecapLangFlagContainer.classList.add('hidden');
          this.filtersRecapLangFlag.removeAttribute('src');
        }
      }

      //then display the recap on the navbar & hide the nb of experiences block
      this.filtersRecap.classList.remove('hidden');
      this.nbExperiencesBlock.classList.add('hidden');

      //change the navbar button text
      if(this.drawerOpenerButtonText)
        this.drawerOpenerButtonText.textContent = this.drawerOpenerButtonText.dataset.modifyText;
    });
  }

  startFiltering(){
    this.applyFiltersButton.disabled = true;
    this.applyFiltersButton.classList.add('loading');
  }

  filteringDone(){
    //check if we need to recompute the reduction for the experiences (if there's an applied gift card / discount code in cookie)
    this.checkExperiencesReduction();

    this.applyFiltersButton.disabled = false;
    this.applyFiltersButton.classList.remove('loading');
    Drawer.closeDrawer(this.applyFiltersButton.closest('.drawer'));

    //put available experiences at the top of the list
    this.sortExperiencesByAvailability();

    if(this.experiencesSection && this.scrollToExperiences){
      //set a timeout to make sure the experiences are sorted and rerendered on the page first
      window.setTimeout(() => {
        smoothScrollTo(this.experiencesSection, 50);
      }, 100);
    }

    //set back to true since it should be false once (because of the trigger on page load)
    this.scrollToExperiences = true;
  }

  checkIfAllRequestsDone(){
    //if ajaxRequestsRunning equals to 0, it means that the function checking
    //all experiences availability has finished and it is the last one
    if(this.ajaxRequestsRunning === 0){
      this.filteringDone();
    }
  }

  /**
   * Triggers the experiences availabilities check on page load.
   *
   * @return {undefined} - No return value.
   */
  triggerCheckOnPageLoad(){
    //in this case, we don't want the scroll to the experiences at page load
    this.scrollToExperiences = false;

    this.checkExperiencesAvailability();
  }


  /**
   * Sorts experiences by availability.
   */
  sortExperiencesByAvailability(){
    const experiencesContainer = document.getElementById('experiences-container');
    if(experiencesContainer){
      // first, delete all H2 tags that are children of experiencesContainer
      const toRemoveElts = experiencesContainer.querySelectorAll('.to-remove-on-filter-sort');
      toRemoveElts.forEach(element => {
        element.remove();
      });

      var experiencesToSort = experiencesContainer.children;
      experiencesToSort = Array.prototype.slice.call(experiencesToSort, 0);

      experiencesToSort.sort(function(a, b) {
        const experienceA = a.firstElementChild;
        const experienceB = b.firstElementChild;
        let aHasClass = experienceA.classList.contains('not-available');
        let bHasClass = experienceB.classList.contains('not-available');

        //put available experiences first
        if (aHasClass && !bHasClass) {
          return 1;
        }
        else if(!aHasClass && bHasClass){
          return -1;
        }

        //then put experiences with the better average review first
        if (experienceA.dataset.note > experienceB.dataset.note) {
          return -1;
        }
        else if (experienceA.dataset.note < experienceB.dataset.note) {
            return 1;
        }

        return 0;
      });

      experiencesContainer.innerHTML = "";
      for(var i = 0; i < experiencesToSort.length; i++) {
        experiencesContainer.appendChild(experiencesToSort[i]);
      }
    }
  }

  //if there's an applied gift card / discount code in cookie, check if we need to recompute the reduction
  checkExperiencesReduction(){
    const experiences = document.querySelectorAll('.card-experience-host-page__price.check-reduction');
    if(experiences.length > 0){
      experiences.forEach(experience => {
        let adultSeats = experience.dataset.reductionAdultSeats;
        let childSeats = experience.dataset.reductionChildSeats;

        if(this.adultsPicker.value > 0){
          adultSeats = this.adultsPicker.value;
          childSeats = this.childrenPicker.value;
        }

        computeReduction(experience, Number(adultSeats), Number(childSeats));
      });
    }
  }

  /**
   * Computes the discounted GTTD price for one unit in cents.
   *
   * @param {HTMLElement} priceContainer - Card price container
   * @param {number} originalPriceCents - Original unit price in cents
   * @return {number}
   */
  computeGttdDiscountedPriceCents(priceContainer, originalPriceCents){
    const discountCents = Math.min(
      Math.round(Number(originalPriceCents) * Number(priceContainer.dataset.gttdDiscountRate) / 100),
      Number(priceContainer.dataset.gttdDiscountCapCents)
    );

    return Math.max(0, Number(originalPriceCents) - discountCents);
  }

  /**
   * Computes original, discounted and saved totals for filtered visitors.
   * Specific timeslot pricing is used when the selected date overrides default prices.
   *
   * @param {HTMLElement} priceContainer - Card price container
   * @param {Object} timeslot - First available timeslot
   * @param {number} adultsCount - Selected adults
   * @param {number} childrenCount - Selected children
   * @return {Object|null}
   */
  getFilteredGttdTotals(priceContainer, timeslot, adultsCount, childrenCount){
    if(priceContainer.dataset.gttdDiscountActive !== 'true' || !timeslot.pricing){
      return null;
    }

    const adultPriceCents = Math.round(Number(timeslot.pricing.adult_price_with_tax) * 100);
    const childPriceCents = Math.round(Number(timeslot.pricing.child_price_with_tax) * 100);
    const discountedTotalInHostCurrency = (
      adultsCount * this.computeGttdDiscountedPriceCents(priceContainer, adultPriceCents)
      + childrenCount * this.computeGttdDiscountedPriceCents(priceContainer, childPriceCents)
    ) / 100;
    const hostCurrencyConversionRate = Number(timeslot.pricing.host_currency_conversion_rate);
    const discountedTotalInEuros = hostCurrencyConversionRate > 0
      ? discountedTotalInHostCurrency / hostCurrencyConversionRate
      : discountedTotalInHostCurrency;
    const originalTotalInEuros = Number(timeslot.total_price_in_euros);

    return {
      original: originalTotalInEuros,
      discounted: discountedTotalInEuros,
      saving: Math.max(0, originalTotalInEuros - discountedTotalInEuros)
    };
  }

  /**
   * Updates the price display to show the total for the filtered visitors
   *
   * @param {HTMLElement} card - The experience card element
   * @param {Object} timeslot - The first timeslot with pricing information
   */
  updateFilteredPrice(card, timeslot){
    const priceContainer = card.querySelector('.card-experience-host-page__price');
    if(!priceContainer) return;

    // Get the total price in euros from the timeslot (already calculated on backend)
    let totalPriceInEuros = Number(timeslot.total_price_in_euros);

    // Get the visitor's currency info from the body dataset
    const visitorCurrencyIso = document.body.dataset.currencyIso;
    const visitorCurrencyLocale = document.body.dataset.lang;
    const hostCurrencyRate = parseFloat(document.body.dataset.currencyRate || 1);

    const adultsCount = Number(this.adultsPicker.value || 0);
    const childrenCount = Number(this.childrenPicker.value || 0);
    const personsCount = adultsCount + childrenCount;
    const personsLabel = personsCount === 1
      ? '(' + priceContainer.dataset.filteredPricePersonLabel + ')'
      : '(' + priceContainer.dataset.filteredPricePersonsLabel.replace('{0}', personsCount) + ')';

    // Store original HTML if not already stored
    if(!priceContainer.dataset.originalHtml){
      priceContainer.dataset.originalHtml = priceContainer.innerHTML;
    }

    const gttdTotals = this.getFilteredGttdTotals(
      priceContainer,
      timeslot,
      adultsCount,
      childrenCount
    );
    const convertAndFormatPrice = (priceInEuros) => {
      let price = priceInEuros;
      if(hostCurrencyRate && hostCurrencyRate !== 1){
        price = priceInEuros * hostCurrencyRate;
      }

      return price.toLocaleString(visitorCurrencyLocale.replace('_', '-'), {
        style: 'currency',
        currency: visitorCurrencyIso
      });
    };

    if(gttdTotals){
      const formattedDiscountedPrice = convertAndFormatPrice(gttdTotals.discounted);
      const formattedOriginalPrice = convertAndFormatPrice(gttdTotals.original);
      const formattedSaving = convertAndFormatPrice(gttdTotals.saving);
      const saveLabel = priceContainer.dataset.gttdSaveLabel.replace('{0}', formattedSaving);
      const offerIcon = priceContainer.querySelector('.gttd-offer-icon');

      priceContainer.innerHTML = `
      <div class="flex flex-wrap items-center leading-tight">
        <span class="flex items-center mr-2">
          <span>${formattedDiscountedPrice}</span>
          <span class="text-sm text-gray-500 line-through ml-2">${formattedOriginalPrice}</span>
          <span class="font-normal text-xs ml-2">${personsLabel}</span>
        </span>
        <span class="px-2 py-1 flex flex-wrap items-center justify-center text-xs font-normal leading-tight mt-1 rounded-md bg-me-light-green-alt text-me-forest-green" data-gttd-offer-label>
          <span class="whitespace-no-wrap">${priceContainer.dataset.gttdSpecialOfferLabel}</span>
          <span class="whitespace-no-wrap ml-1">- ${saveLabel}</span>
        </span>
      </div>`;

      if(offerIcon){
        priceContainer.querySelector('[data-gttd-offer-label]').appendChild(offerIcon);
      }

      return;
    }

    const formattedPrice = convertAndFormatPrice(totalPriceInEuros);

    // Update the price display
    priceContainer.innerHTML = `
    <span class="flex items-center leading-tight">
      <span class="leading-tight">${formattedPrice}</span>
      <span class="font-normal text-xs ml-2">${personsLabel}</span>
    </span>`;
  }

  /**
   * Clears the filtered price and restores the original price display
   *
   * @param {HTMLElement} card - The experience card element
   */
  clearFilteredPrice(card){
    const priceContainer = card.querySelector('.card-experience-host-page__price');
    if(!priceContainer) return;

    // Restore original HTML if it was stored
    if(priceContainer.dataset.originalHtml){
      priceContainer.innerHTML = priceContainer.dataset.originalHtml;
      delete priceContainer.dataset.originalHtml;
    }
  }
}

export default SessionFilters;
